module.exports = __webpack_public_path__ + "img/img-134.bc159d9e.png";